import * as React from "react";
import Photo from "../model/Photo";
import PhotoViewer from "./PhotoViewer";

interface AlbumViewerProps {
  portraitPhotos: Photo[];
  landscapePhotos: Photo[];
  action: DownloadGalleryPhotosAction;
  selectedPhoto?: Photo;
}

interface AlbumViewerState {
  selectedPhoto: Photo;
}

export interface DownloadGalleryPhotosAction {
  url: string;
}

export default class AlbumViewer extends React.Component<AlbumViewerProps, AlbumViewerState> {
  constructor(props: AlbumViewerProps) {
    super(props);
    this.state = {
      selectedPhoto:
        props.selectedPhoto ||
        (this.props.portraitPhotos.length >= 1
          ? this.props.portraitPhotos[0]
          : props.landscapePhotos[0]),
    };
  }

  render() {
    return (
      <div className="album-viewer">
        <PhotoViewer photo={this.state.selectedPhoto} />
        <div className="photo-grid-container h-flex with-separator justify-center no-wrap">
          {this.props.portraitPhotos.length >= 1 && (
            <div className="album-photo-grid portrait">
              {this.props.portraitPhotos.map((photo) => (
                <PhotoViewer
                  photo={photo}
                  key={photo.uid}
                  onPhotoClicked={() => this.setState({ selectedPhoto: photo })}
                />
              ))}
            </div>
          )}
          <div className="album-photo-grid">
            {this.props.landscapePhotos.map((photo) => (
              <PhotoViewer
                photo={photo}
                key={photo.uid}
                onPhotoClicked={() => this.setState({ selectedPhoto: photo })}
              />
            ))}
          </div>
        </div>
        {this.props.action?.url && (
          <a className="button-primary reverse" target="_blank" href={this.props.action.url}>
            {i18n["Global.DownloadPhotos"]}
          </a>
        )}
      </div>
    );
  }
}
